import { render, staticRenderFns } from "./InstallmentPolicyList.vue?vue&type=template&id=e550efc6&scoped=true&"
import script from "./InstallmentPolicyList.vue?vue&type=script&lang=js&"
export * from "./InstallmentPolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e550efc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e550efc6')) {
      api.createRecord('e550efc6', component.options)
    } else {
      api.reload('e550efc6', component.options)
    }
    module.hot.accept("./InstallmentPolicyList.vue?vue&type=template&id=e550efc6&scoped=true&", function () {
      api.rerender('e550efc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/settings/financial/installment-policy/InstallmentPolicyList.vue"
export default component.exports